/**
 * サイト全体の埋め込み（LINEボタン・メルマガ登録ポップアップ・ヒートマップ計測・アフィリエイト紹介コード）
 *
 * 設定は sections/nekonimo-app-embeds.liquid が window.NAE_CONFIG に埋め込んで渡す
 * （LINEボタンの文言・URLはHTMLに直接出しているためJS側の設定は持たない）。
 *
 * 4機能はそれぞれ独立していて、cfg の enabled が false、または対応するHTML要素が
 * 無ければ何もしない。
 */
(function () {
  var CFG = (typeof window !== 'undefined' && window.NAE_CONFIG) || {};

  // ---------- 純粋ロジック（node からも直接テストできるようDOM非依存にする） ----------

  // ?ref= / ?aff= の紹介コードとして受け付けられる形式か（英数字・ハイフン・下線、最大32字）
  function isValidAffiliateCode(code) {
    return typeof code === 'string' && /^[A-Za-z0-9_-]{1,32}$/.test(code);
  }

  // node で require されたときは、ここから先のDOM操作を実行せず純粋関数だけを公開する
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { isValidAffiliateCode: isValidAffiliateCode };
    return;
  }

  // ---------- a. LINEボタン（Chatyの置き換え） ----------
  // PCはCSSの :hover で表示。スマホは初回表示時だけ数秒出す
  (function lineTooltip() {
    var tip = document.getElementById('nae-line-tip');
    if (!tip) return;
    if (window.innerWidth >= 750) return;
    tip.classList.add('is-visible');
    setTimeout(function () {
      tip.classList.remove('is-visible');
    }, 4000);
  })();

  // ---------- b. メルマガ登録ポップアップ（Mailchimp/Klaviyo/Omnisendの置き換え） ----------
  (function newsletterPopup() {
    var cfg = CFG.news || {};
    var modal = document.getElementById('nae-news-modal');
    if (!cfg.enabled || !modal) return;

    // /cart と /checkout 系のページでは出さない
    var path = window.location.pathname;
    if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) return;

    var STORAGE_KEY = 'nae_news_dismissed_at';
    var closeBtn = document.getElementById('nae-news-close');
    var form = document.getElementById('nae-news-form');

    function readDismissedAt() {
      try {
        return Number(window.localStorage.getItem(STORAGE_KEY)) || 0;
      } catch (e) {
        return 0;
      }
    }
    function writeDismissedAt() {
      try {
        window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } catch (e) {
        /* localStorageが使えなくても致命的ではないので無視する */
      }
    }

    function open() {
      modal.classList.add('is-open');
    }
    function close() {
      modal.classList.remove('is-open');
      writeDismissedAt();
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    // 送信後のページ（成功・エラーとも）では待たずに開いて結果を見せる。
    // 成功時は次回アクセス時の再表示だけ抑止する
    if (form && form.querySelector('.nae-news-success')) {
      writeDismissedAt();
      open();
      return;
    }
    if (form && form.querySelector('.nae-news-error')) {
      open();
      return;
    }

    var recheckMs = (cfg.recheckDays || 14) * 24 * 60 * 60 * 1000;
    if (Date.now() - readDismissedAt() < recheckMs) return;

    setTimeout(open, (cfg.delaySec || 0) * 1000);
  })();

  // ---------- c. ヒートマップ計測タグ（Lucky Orangeの置き換え） ----------
  (function heatmap() {
    var cfg = CFG.heatmap || {};
    if (!cfg.enabled || !cfg.endpoint) return;
    if (Math.random() * 100 > (cfg.sampling == null ? 100 : cfg.sampling)) return;

    var events = [];
    var maxScrollBottom = 0;

    // セレクタは短く（tag + id、無ければ最初のclass）。入力値・クエリ文字列は持たない
    function shortSelector(el) {
      if (!el || el.nodeType !== 1) return '';
      var tag = el.tagName.toLowerCase();
      if (el.id) return tag + '#' + el.id;
      var cls = typeof el.className === 'string' ? el.className.trim().split(/\s+/)[0] : '';
      return cls ? tag + '.' + cls : tag;
    }

    document.addEventListener(
      'click',
      function (e) {
        events.push({
          t: 'c',
          x: Math.round((e.clientX / window.innerWidth) * 1000) / 1000,
          y: Math.round(window.scrollY + e.clientY),
          s: shortSelector(e.target)
        });
      },
      true
    );

    window.addEventListener(
      'scroll',
      function () {
        var bottom = window.scrollY + window.innerHeight;
        if (bottom > maxScrollBottom) maxScrollBottom = bottom;
      },
      { passive: true }
    );

    function send() {
      if (!events.length && !maxScrollBottom) return;
      var payload = {
        p: window.location.pathname,
        d: window.innerWidth < 750 ? 'm' : 'd',
        w: window.innerWidth,
        h: document.documentElement.scrollHeight,
        ev: events.slice()
      };
      if (maxScrollBottom) payload.ev.push({ t: 's', y: Math.round(maxScrollBottom) });

      var blob = new Blob([JSON.stringify(payload)], { type: 'text/plain' });
      navigator.sendBeacon(cfg.endpoint.replace(/\/$/, '') + '/hm/collect', blob);
      events = [];
      maxScrollBottom = 0;
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') send();
    });
    window.addEventListener('pagehide', send);
  })();

  // ---------- d. アフィリエイト紹介コード記録（まるっと集客/Affitchの置き換え） ----------
  (function affiliate() {
    var cfg = CFG.affiliate || {};
    if (!cfg.enabled) return;

    var STORAGE_KEY = 'nae_affiliate';

    function readStored() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || !isValidAffiliateCode(data.code) || !data.expires || data.expires < Date.now()) return null;
        return data;
      } catch (e) {
        return null;
      }
    }
    function writeStored(code, days) {
      try {
        window.localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({ code: code, expires: Date.now() + days * 24 * 60 * 60 * 1000 })
        );
      } catch (e) {
        /* localStorageが使えなければ保持できないだけで致命的ではない */
      }
    }

    var params = new URLSearchParams(window.location.search);
    var incoming = params.get('ref') || params.get('aff');
    if (isValidAffiliateCode(incoming)) {
      writeStored(incoming, cfg.days || 30);
    }

    var stored = readStored();
    if (!stored) return;

    // 毎ページ更新すると無駄なので、現在のカートの値と違うときだけ更新する
    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (cart.attributes && cart.attributes.affiliate === stored.code) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { affiliate: stored.code } })
        });
      })
      .catch(function () {
        /* 通信に失敗しても致命的ではないので無視する */
      });
  })();
})();
